module.exports = __webpack_public_path__ + "img/otros.6c496eaa.jpg";